import { render, staticRenderFns } from "./TreatmentSketchAppointment.vue?vue&type=template&id=63689c48&scoped=true&"
import script from "./TreatmentSketchAppointment.vue?vue&type=script&lang=js&"
export * from "./TreatmentSketchAppointment.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSketchAppointment.vue?vue&type=style&index=0&id=63689c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63689c48",
  null
  
)

export default component.exports